import React from 'react';
import classNames from 'classnames';
import { CaretBottomIcon } from '../../../Icons';
import TinyPopover from '../../../TinyPopover';
import DropdownOptions from './DropdownOptions';
var Dropwdown = React.memo(function (_ref) {
  var label = _ref.label,
      open = _ref.open,
      currentItem = _ref.currentItem,
      items = _ref.items,
      _ref$onItemClick = _ref.onItemClick,
      onItemClick = _ref$onItemClick === void 0 ? function () {
    return true;
  } : _ref$onItemClick,
      _ref$onDropdownClick = _ref.onDropdownClick,
      onDropdownClick = _ref$onDropdownClick === void 0 ? function () {
    return true;
  } : _ref$onDropdownClick;
  return React.createElement("div", {
    className: "background-white padding-medium"
  }, React.createElement("div", {
    className: classNames('shade-05')
  }, React.createElement("div", {
    className: "padding-bottom-small font-weight-medium"
  }, label), React.createElement(TinyPopover, {
    horizontalPadding: 24,
    verticalPadding: 6,
    isOpen: open,
    position: "bottom",
    containerStyle: {
      overflow: 'visible',
      zIndex: '4'
    },
    content: React.createElement(DropdownOptions, {
      onItemClick: onItemClick,
      currentItem: currentItem,
      items: items
    }),
    className: classNames(['slite-editor-database-popover slite-design-system', 'zindex-large', 'radius-normal scroll-y', 'background-white border-none', 'shadow-hovering'])
  }, React.createElement("div", {
    "data-qa": "database-column-option-change-type",
    onClick: onDropdownClick,
    className: classNames('flexbox flexbox-align-center pointer', 'padding-horizontal-normal padding-vertical-small', 'border-solid radius-normal border-small border-shade-40 border-primary-on-hover', 'shade-20 shade-10-on-hover', open ? 'border-primary' : '')
  }, React.createElement("div", {
    className: "shade-30 margin-right-normal line-height-one"
  }, currentItem.icon || currentItem.getIcon()), React.createElement("div", {
    className: "shade-10 font-weight-medium flexbox-grow"
  }, currentItem.label || currentItem.getLabel()), React.createElement(CaretBottomIcon, {
    size: 8
  })))));
});
export default Dropwdown;